import lang from 'lang'

export const FILE_LIST_TYPE = Object.freeze({
  thumbs: 'thumbs',
  list: 'list',
})
export const SORTABLE_FILE_FIELDS = Object.freeze({
  createdAt: 'createdAt',
  recordDate: 'recordDate',
  addedAt: 'addedAt',
})
export const TAG_TYPES = Object.freeze({
  NOT_ASSIGNED: 'notAssigned',
  INVOICE: 'invoice',
  COUNT_REPORT: 'zReport',
  INTERIM_REPORT: 'xReport',
  DEPOSIT: 'deposit',
  WITHDRAWAL: 'withdrawal',
  INCOMING_INVOICE: 'incomingInvoice',
  INVOICE_CORRECTION: 'invoiceCorrection',
  CONTRACT: 'contract',
  CUSTOM: 'custom',
  DOCUMENTS: 'documents',
  CANCELLATION: 'cancellation',
})
export const TAG_LABELS = Object.freeze({
  NOT_ASSIGNED: lang.tags.NOT_ASSIGNED,
  CONTRACT: lang.tags.CONTRACT,
  INCOMING_INVOICE: lang.tags.INCOMING_INVOICE,
  INVOICE_CORRECTION: lang.tags.INVOICE_CORRECTION,
  INVOICE: lang.tags.INVOICE,
  CANCELLATION: lang.tags.CANCELLATION,
  DEPOSIT: lang.tags.DEPOSIT,
  WITHDRAWAL: lang.tags.WITHDRAWAL,
  INTERIM_REPORT: lang.tags.INTERIM_REPORT,
  COUNT_REPORT: lang.tags.COUNT_REPORT,
})
export const REMOVABLE_SYSTEM_TAGS = Object.freeze({
  NOT_ASSIGNED: {
    type: TAG_TYPES.NOT_ASSIGNED,
    label: TAG_LABELS.NOT_ASSIGNED,
  },
})
export const ASSIGNABLE_SYSTEM_TAGS = Object.freeze({
  CONTRACT: {
    type: TAG_TYPES.CONTRACT,
    label: TAG_LABELS.CONTRACT,
  },
  INCOMING_INVOICE: {
    type: TAG_TYPES.INCOMING_INVOICE,
    label: TAG_LABELS.INCOMING_INVOICE,
  },
  INVOICE_CORRECTION: {
    type: TAG_TYPES.INVOICE_CORRECTION,
    label: TAG_LABELS.INVOICE_CORRECTION,
  },
  INVOICE: {
    type: TAG_TYPES.INVOICE,
    label: TAG_LABELS.INVOICE,
  },
})
// Lives in its own leaf module so helpers can read it without pulling `lang` in through this file;
// re-exported here so every existing importer keeps working. See external-owner-systems.ts.
export { EXTERNAL_OWNER_SYSTEMS } from '@/modules/file/external-owner-systems'
export const RELATION_TYPES = Object.freeze({
  document: 'document',
  user: 'user',
})
